import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import DocumentationView from '@/views/DocumentationView.vue'
import SearchView from '@/views/SearchView.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Home - Documentation',
    },
  },
  {
    path: '/docs',
    name: 'documentation-home',
    component: DocumentationView,
    props: true,
    meta: {
      title: 'Documentation',
    },
  },
  {
    path: '/docs/information/:section*',
    name: 'information',
    component: DocumentationView,
    props: true,
    meta: {
      title: 'Information',
    },
  },
  {
    path: '/docs/standards/:section*',
    name: 'standards',
    component: DocumentationView,
    props: true,
    meta: {
      title: 'Standards',
    },
  },
  {
    path: '/docs/documentation/:section',
    name: 'documentation-section',
    component: DocumentationView,
    props: true,
    meta: {
      title: 'Documentation',
    },
  },

  {
    path: '/docs/:category/:section*',
    name: 'documentation-generic',
    component: DocumentationView,
    props: true,
    meta: {
      title: 'Documentation',
    },
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView,
    meta: {
      title: 'Search Documentation',
    },
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: {
      title: 'Page Not Found',
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    } else {
      return { top: 0 }
    }
  },
})

// Update page title on route change
router.beforeEach((to, _from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  }
  next()
})

export default router
